<template>
  <div class="jenkins-detail">
    <Build ref="Build" v-on:buildComplete="buildComplete"></Build>
    <ConsoleLogOutput ref="ConsoleLogOutput"></ConsoleLogOutput>
    <Row :gutter="16">
      <Col :lg="4" style="padding: 5px">
        <JenkinsMain ref="JenkinsMain" :currentJenkinsId="$route.params.id"></JenkinsMain>
        <!--<Card :padding="0" shadow style="margin-bottom: 10px">-->
          <!--<div slot="title" style="font-weight: bold; color: #000;">-->
            <!--<Icon type="ios-options"></Icon>-->
            <!--<span> Jenkins列表</span>-->
          <!--</div>-->
          <!--<CellGroup style="padding: 5px 0;" @on-click="cellClick">-->
            <!--<Cell title="Job列表" name="monitor" extra="〉" :selected="cell === 'jobs'" />-->
          <!--</CellGroup>-->
        <!--</Card>-->
        <Card :padding="0" shadow style="margin-bottom: 10px">
          <div slot="title" style="font-weight: bold; color: #000;">
            <Icon type="ios-options"></Icon>
            <span> 构建队列</span>
          </div>
          <CellGroup style="padding: 5px 0;">
            <Alert show-icon type="warning" style="margin: 0 5px;" v-if="buildQueueError">获取数据失败</Alert>
            <div v-else>
              <Cell v-for="(buildQueueItem, buildQueueIndex) in buildQueue" :key="buildQueueIndex" v-if="buildQueueItem.task" :name="buildQueueItem.task.name">
                <a v-on:click="$router.push({name: 'jenkins_job_detail', params: { id: $route.params.id, job_name: buildQueueItem.task.name }})">{{ buildQueueItem.task.name }}</a>
                <a style="color: red;" slot="extra" v-on:click="cancelQueue(buildQueueItem.id)"><Icon type="md-close-circle" size="16" /></a>
              </Cell>
            </div>
          </CellGroup>
        </Card>
        <Card :padding="0" shadow>
          <div slot="title" style="font-weight: bold; color: #000;">
            <Icon type="ios-options"></Icon>
            <span> 构建中</span>
          </div>
          <CellGroup style="padding: 5px 0;">
            <Alert show-icon type="warning" style="margin: 0 5px;" v-if="runningBuildError">获取数据失败</Alert>
            <div v-else>
              <Cell v-for="(runningBuildItem, runningBuildIndex) in runningBuild" :key="runningBuildIndex" :name="runningBuildItem.name">
                <a v-on:click="$router.push({name: 'jenkins_job_detail', params: { id: $route.params.id, job_name: runningBuildItem.name }})">{{ runningBuildItem.name }}</a>
                <a style="color: red;" slot="extra" v-on:click="cancelBuild(runningBuildItem.name, runningBuildItem.number)"><Icon type="md-close-circle" size="16" /></a>
              </Cell>
            </div>
          </CellGroup>
        </Card>
      </Col>
      <Col :lg="20" style="padding: 5px">
        <Card v-show="cell === 'jobs'" shadow>
          <Tabs :value="jobSearchForm.view_name" @on-click="viewsTabClick">
            <TabPane :label="item.name" :name="item.name" v-for="(item, index) in viewsList" :key="'view_' + index"></TabPane>
          </Tabs>
          <Alert v-if="jobsListError" type="warning" show-icon>获取数据失败</Alert>
          <div v-else>
            <div v-if="jobSearchForm.folder_name">
              <Breadcrumb>
                <BreadcrumbItem><a v-on:click="folderClick(-1)">Home</a></BreadcrumbItem>
                <BreadcrumbItem v-for="(item, idx) in jobSearchForm.folder_name.split('/')" :key="idx"><a v-on:click="folderClick(idx)">{{ item }}</a></BreadcrumbItem>
              </Breadcrumb>
              <Divider/>
            </div>
            <Form :model="jobSearchForm" ref="jobSearchForm" inline :label-width="40" @submit.native.prevent>
              <FormItem label="筛选">
                <Input v-model="jobSearchForm.job_name" style="min-width: 200px" placeholder="Job名称" @on-enter="getfilterJobs()" clearable/>
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
                <Button type="primary" style="margin-right:5px;" @click="getJobs()">搜索</Button>
                <Button type="primary"  @click="buildAllButton()">构建</Button>
              </FormItem>
            </Form>
            <Table
              stripe
              border
              highlight-row
              @on-sort-change="sortChange"
              @on-selection-change="selectChange"
              :loading="jobsTableLoading"
              ref="jobsTable"
              :data="jobs.data"
              :columns="jobs.columns"></Table>
            <div style="margin: 10px 0; overflow: hidden;">
              <div style="float: left;">
                当前显示 {{ jobs.data.length }} 条记录，总共 {{ jobs.count }} 条记录
              </div>
              <div style="float: right;">
                <page
                  :total="jobs.count"
                  :current="jobs.page"
                  :page-size="jobs.size"
                  @on-change="getJobs"></page>
              </div>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
    <Modal
        title="批量构建"
        v-model="show"
        @on-ok="buildAllJobs"
        :closable="false">
        <p>点击确定将开始构建{{ tableDataSel }}</p>
    </Modal>
  </div>
</template>

<script>
import { detailJenkins, getJenkinsJobs, getJenkinsViews, getJenkinsBuildQueueList, buildJenkinsAllJob,
  cancelJenkinsBuildQueue, getJenkinsRunningBuildList, stopBuildJenkinsJob } from '@/api/tools/jenkins'
import ConsoleLogOutput from './components/console-output'
import Build from './components/build'
import JenkinsMain from './main'
import moment from 'moment'

export default {
  name: 'detail',
  components: {
    JenkinsMain,
    ConsoleLogOutput,
    Build
  },
  created: function () {
    this.init()
    this.setBuildQueueListTimer()
    this.setRunningBuildsListTimer()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
    clearInterval(this.buildQueueTimer)
    this.buildQueueTimer = null
    clearInterval(this.runningBuildTimer)
    this.runningBuildTimer = null
  },
  data () {
    return {
      cell: 'jobs',
      moment: moment,
      show: false,
      building: false,
      // Jenkins
      jenkinsInfo: {},
      jenkinsError: false,
      // Views
      viewsList: [],
      viewsListError: false,
      // Jobs
      jobsTableLoading: false,
      jobsListError: false,
      jobs: {
        data: [],
        columns: [
          {
            type: 'selection',
            width: 60,
            fixed: 'left',
            align: 'center'
          },
          {
            title: 'Job名称',
            key: 'name',
            align: 'center',
            fixed: 'left',
            tooltip: true,
            minWidth: 200,
            render: (h, params) => {
              let aL = []
              if (params.row._class === 'com.cloudbees.hudson.plugins.folder.Folder') {
                aL.push(h('Icon', {
                  props: {
                    type: 'md-folder',
                    size: 20
                  },
                  style: { color: '#2db7f5', marginRight: '5px' }
                }))
                aL.push(h('span', {
                  on: {
                    click: () => {
                      let folders = []
                      if (this.jobSearchForm.folder_name) {
                        folders = this.jobSearchForm.folder_name.split('/')
                      }
                      folders.push(params.row.name)
                      this.jobSearchForm.folder_name = folders.join('/')
                      this.getJobs()
                    }
                  }
                }, params.row.name))
              } else {
                aL.push(h('span', {
                  on: {
                    click: () => {
                      let jobName = params.row.name
                      if (this.jobSearchForm.folder_name) {
                        jobName = `${this.jobSearchForm.folder_name}/${jobName}`
                      }
                      this.$router.push({ name: 'jenkins_job_detail', params: { id: this.$route.params.id, job_name: jobName }, query: { lastPage: this.jobs.page } })
                    }
                  }
                }, params.row.name))
              }
              return h('a', aL)
            }
          },
          {
            title: '描述',
            key: 'description',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '上次成功',
            key: 'last_success_time',
            sortable: 'custom',
            align: 'center',
            tooltip: true,
            minWidth: 180,
            render: (h, params) => {
              if (params.row.last_success_time) {
                return h('span', [
                  h('span', moment(Number(params.row.last_success_time)).format('YYYY-MM-DD HH:mm:ss')),
                  h('a', {
                    on: {
                      click: () => {
                        let jobName = params.row.name
                        if (this.jobSearchForm.folder_name) {
                          jobName = `${this.jobSearchForm.folder_name}/${jobName}`
                        }
                        this.$refs.ConsoleLogOutput.getOutput(this.$route.params.id, jobName, params.row.last_success_number)
                      }
                    }
                  }, ' #' + params.row.last_success_number)
                ])
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '上次失败',
            key: 'last_failure_time',
            sortable: 'custom',
            align: 'center',
            tooltip: true,
            minWidth: 180,
            render: (h, params) => {
              if (params.row.last_failure_time) {
                return h('span', [
                  h('span', moment(Number(params.row.last_failure_time)).format('YYYY-MM-DD HH:mm:ss')),
                  h('a', {
                    on: {
                      click: () => {
                        let jobName = params.row.name
                        if (this.jobSearchForm.folder_name) {
                          jobName = `${this.jobSearchForm.folder_name}/${jobName}`
                        }
                        this.$refs.ConsoleLogOutput.getOutput(this.$route.params.id, jobName, params.row.last_failure_number)
                      }
                    }
                  }, ' #' + params.row.last_failure_number)
                ])
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '上次持续时间',
            key: 'last_duration',
            align: 'center',
            tooltip: true,
            minWidth: 110
          },
          {
            title: '上次构建状态',
            key: 'color',
            align: 'center',
            tooltip: true,
            minWidth: 110,
            render: (h, params) => {
              if (params.row.color) {
                return h('Tag', {
                  props: {
                    color: params.row.color === 'blue' ? 'green'
                      : params.row.color === 'disabled' ? 'default'
                        : params.row.color === 'red' ? 'red'
                          : params.row.color === 'aborted' ? 'gold'
                            : params.row.color === 'notbuilt' ? 'blue'
                              : 'gold'
                  },
                  style: {
                    cursor: 'pointer'
                  },
                  nativeOn: {
                    click: () => {
                      if (params.row.last_build) {
                        let jobName = params.row.name
                        if (this.jobSearchForm.folder_name) {
                          jobName = `${this.jobSearchForm.folder_name}/${jobName}`
                        }
                        this.$refs.ConsoleLogOutput.getOutput(this.$route.params.id, jobName, params.row.last_build.number)
                      }
                    }
                  }
                }, params.row.color === 'blue' ? '成功'
                  : params.row.color === 'disabled' ? '禁用'
                    : params.row.color === 'red' ? '失败'
                      : params.row.color === 'aborted' ? '已终止'
                        : params.row.color === 'notbuilt' ? '未构建'
                          : params.row.color.indexOf('anime') > -1 ? '构建中'
                            : params.row.color)
              } else {
                return ''
              }
            }
          },
          {
            title: '队列中',
            key: 'inQueue',
            align: 'center',
            tooltip: true,
            minWidth: 80,
            render: (h, params) => {
              if (params.row._class === 'com.cloudbees.hudson.plugins.folder.Folder') {
                return h('span', '')
              }
              return h('Tag', {
                props: {
                  color: params.row.inQueue ? 'blue' : 'default'
                }
              }, params.row.inQueue ? '是' : '否')
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 210,
            render: (h, params) => {
              if (params.row._class === 'com.cloudbees.hudson.plugins.folder.Folder') {
                return h('span', '')
              }
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let jobName = params.row.name
                      if (this.jobSearchForm.folder_name) {
                        jobName = `${this.jobSearchForm.folder_name}/${jobName}`
                      }
                      this.$router.push({ name: 'jenkins_job_detail', params: { id: this.$route.params.id, job_name: jobName } })
                    }
                  }
                }, '详情'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    loading: params.row.inQueue || params.row.color.indexOf('anime') > -1,
                    disabled: !params.row.buildable
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      let jobName = params.row.name
                      if (this.jobSearchForm.folder_name) {
                        jobName = `${this.jobSearchForm.folder_name}/${jobName}`
                      }
                      this.$refs.Build.start(this.$route.params.id, jobName)
                    }
                  }
                }, '构建'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      window.open(params.row.url + '/configure', '_blank')
                    }
                  }
                }, '编辑')
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      jobSearchForm: {
        folder_name: '',
        view_name: 'all',
        job_name: ''
      },
      timer: null,
      // Build Queues
      buildQueue: [],
      buildQueueTimer: null,
      buildQueueError: false,
      // Running Builds
      runningBuild: [],
      runningBuildTimer: null,
      runningBuildError: false
    }
  },
  methods: {
    // 初始化
    init () {
      this.jobSearchForm.folder_name = ''
      this.jobSearchForm.view_name = 'all'
      this.jobSearchForm.job_name = ''
      this.tableDataSel = []
      this.getJenkinsDetailData()
      this.getViews()
      this.getJobs(this.$route.query.page ? parseInt(this.$route.query.page) : 1)
      this.getBuildQueues()
    },
    folderClick (depth) {
      if (depth < 0) {
        this.jobSearchForm.folder_name = ''
      } else {
        this.jobSearchForm.folder_name = this.jobSearchForm.folder_name.split('/').slice(0, depth + 1).join('/')
      }
      this.getJobs()
    },
    // 构建所有jenkins job
    buildAllButton () {
      if (this.tableDataSel.length > 0) {
        this.show = true
      } else {
        this.$Notice.warning({
          title: '请先选择Job'
        })
      }
    },

    selectChange (selection) {
      this.tableDataSel = []
      this.tableDataSel = selection.map(item => {
        if (this.jobSearchForm.folder_name) {
          return this.jobSearchForm.folder_name + '/' +  item.name
        }
        else {
          return item.name
        }
      })
      console.log(this.tableDataSel)
    },

    buildAllJobs () {
      this.building = true
      buildJenkinsAllJob(this.$route.params.id, this.tableDataSel).then(res => {
        this.$Notice.success({ title: '已加入构建队列！' })
        this.show = false
        this.building = false
      }).catch(res => {
        this.building = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '构建失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '构建失败！'
          })
        }
      })
    },

    // 获取Jenkins详细信息
    getJenkinsDetailData () {
      this.jenkinsError = false
      detailJenkins(this.$route.params.id).then(res => {
        this.jenkinsInfo = res.data
      }).catch(res => {
        console.log(res.response)
        this.jenkinsError = true
      })
    },
    // 获取View
    getViews () {
      this.viewsListError = false
      getJenkinsViews(this.$route.params.id).then(res => {
        this.viewsList = res.data
      }).catch(res => {
        console.log(res.response)
        this.viewsListError = true
      })
    },
    // 获取Job列表
    getfilterJobs () {
      this.jobSearchForm.folder_name = ''
      this.getJobs()
    },
    getJobs (value = 1, loading = true) {
      this.jobs.page = value
      this.jobsListError = false
      this.jobsTableLoading = loading
      this.jobSearchForm['size'] = this.jobs.size
      this.jobSearchForm['page'] = this.jobs.page
      getJenkinsJobs(this.$route.params.id, this.jobSearchForm).then(res => {
        let result = res.data
        this.jobs.data = result.results
        for (var i = 0; i < this.jobs.data.length; i++) {
          if (this.jobs.data[i].buildable == false || this.jobs.data[i]._class === 'com.cloudbees.hudson.plugins.folder.Folder') {
            this.jobs.data[i]['_disabled'] = true
          }
        }
        this.jobs.count = result.count
        this.jobsTableLoading = false
        let haveInQueue = false
        if (loading) {
          for (let i in this.jobs.data) {
            if (!this.jobs.data[i]._class === 'com.cloudbees.hudson.plugins.folder.Folder') {
              if (this.jobs.data[i].inQueue || this.jobs.data[i].color.indexOf('anime') > -1) {
                this.setTimer()
                break
              }
            }
          }
        } else {
          for (let i in this.jobs.data) {
            if (!this.jobs.data[i]._class === 'com.cloudbees.hudson.plugins.folder.Folder') {
              if (this.jobs.data[i].inQueue || this.jobs.data[i].color.indexOf('anime') > -1) {
                haveInQueue = true
                break
              }
            }
          }
          if (!haveInQueue) {
            clearInterval(this.timer)
            this.timer = null
          }
        }
      }).catch(res => {
        console.error(res)
        this.jobsTableLoading = false
        this.jobsListError = true
      })
    },
    // 自动刷新Job列表
    setTimer (timer = 2000) {
      clearInterval(this.timer)
      this.timer = null
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getJobs(this.jobs.page, false)
        }, timer)
      }
    },
    viewsTabClick (name) {
      this.jobSearchForm.ordering = ''
      this.jobSearchForm.view_name = name
      this.jobSearchForm.job_name = ''
      this.getJobs()
    },
    buildComplete (jobName, queueNumber) {
      this.getJobs(this.jobs.page)
    },
    // 获取构建队列
    getBuildQueues () {
      getJenkinsBuildQueueList(this.$route.params.id).then(res => {
        this.buildQueue = res.data
        if (this.buildQueueError) {
          this.buildQueueError = false
        }
      }).catch(res => {
        console.log(res.response)
        this.buildQueueError = true
      })
    },
    // 自动获取构建队列
    setBuildQueueListTimer () {
      clearInterval(this.buildQueueTimer)
      this.buildQueueTimer = null
      if (this.buildQueueTimer == null) {
        this.buildQueueTimer = setInterval(() => {
          this.getBuildQueues()
        }, 2000)
      }
    },
    // 移除构建队列
    cancelQueue (queueId) {
      cancelJenkinsBuildQueue(this.$route.params.id, queueId)
    },
    // 获取构建中的job
    getRunningBuilds () {
      getJenkinsRunningBuildList(this.$route.params.id).then(res => {
        this.runningBuild = res.data
        if (this.runningBuildError) {
          this.runningBuildError = false
        }
      }).catch(res => {
        console.log(res.response)
        this.runningBuildError = true
      })
    },
    // 自动获取构建中的job
    setRunningBuildsListTimer () {
      clearInterval(this.runningBuildTimer)
      this.runningBuildTimer = null
      if (this.runningBuildTimer == null) {
        this.runningBuildTimer = setInterval(() => {
          this.getRunningBuilds()
        }, 2000)
      }
    },
    // 取消构建
    cancelBuild (jobName, buildNumber) {
      stopBuildJenkinsJob(this.$route.params.id, jobName, buildNumber).then(res => {
        this.getRunningBuilds()
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '取消构建失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '取消构建失败！'
          })
        }
      })
    },
    // 排序
    sortChange (params) {
      if (params.order === 'asc') {
        this.jobSearchForm.ordering = params.key
      } else if (params.order === 'desc') {
        this.jobSearchForm.ordering = '-' + params.key
      } else {
        this.jobSearchForm.ordering = ''
      }
      this.getJobs()
    }
  }
}
</script>

<style scoped>

</style>
